import { SwitchField, TextField } from '~/common/components';
import { Trans } from '~/common/context';
import { Card, Col, Row, Title } from '@wyz/ui';
import { useOnMount } from '@wyz/utils';
import { useFormContext } from 'react-hook-form';
import { CUSTOMER_LEVEL } from '@wyz/types';
import {
  useCustomerFormLevel,
  useCustomerFormParentCustomer,
  useCustomerFormPrivileges,
} from '~/connect/hooks';
import { CustomerFormProps, ICustomerConfigurationForm } from '~/connect/types';

const ConfigurationForm = ({
  forms,
  mode,
  customer,
  isWriting,
}: CustomerFormProps) => {
  const methods = useFormContext<ICustomerConfigurationForm>();
  const watchedLevel = useCustomerFormLevel({
    parent: forms.GENERAL_FORM.methods.getValues('parent'),
  });

  const parentCustomerQuery = useCustomerFormParentCustomer({
    methods: forms.GENERAL_FORM.methods,
  });
  const parentCustomer = parentCustomerQuery.data?.data;

  useOnMount(() => {
    if (mode === 'CREATE') {
      if (watchedLevel > CUSTOMER_LEVEL.N1) {
        methods.setValue(
          'configuration.buyerId',
          parentCustomer?.configuration.buyerId,
        );
        methods.setValue(
          'configuration.orderingId',
          parentCustomer?.configuration.orderingId,
        );
        methods.setValue(
          'configuration.consigneeId',
          parentCustomer?.configuration.consigneeId,
        );
      }
    }
  });

  const FormPrivileges = useCustomerFormPrivileges({
    customer: customer,
    level: watchedLevel,
  });

  return (
    <Card>
      <Card.Header>
        <Title heading='lg' color='tertiary' weight='bold'>
          <Trans i18nKey='app.entity.tab.config' />
        </Title>
      </Card.Header>
      <Card.Body>
        {(FormPrivileges.CONFIGURATION_FORM.fields.BUYER_ID.visible ||
          FormPrivileges.CONFIGURATION_FORM.fields.ORDERING_ID.visible ||
          FormPrivileges.CONFIGURATION_FORM.fields.CONSIGNEE_ID.visible) && (
          <Title heading='lg' weight='semi-bold' color='primary'>
            <Trans i18nKey='app.entity.form.configuration.edi_wheel_title' />
          </Title>
        )}
        <Row>
          {FormPrivileges.CONFIGURATION_FORM.fields.BUYER_ID.visible && (
            <Col>
              <TextField
                name='configuration.buyerId'
                label={
                  <Trans i18nKey='app.entity.form.billing_information.buyer_id' />
                }
              />
            </Col>
          )}
          {FormPrivileges.CONFIGURATION_FORM.fields.ORDERING_ID.visible && (
            <Col>
              <TextField
                name='configuration.orderingId'
                label={
                  <Trans i18nKey='app.entity.form.configuration.ordering_id' />
                }
              />
            </Col>
          )}
          {FormPrivileges.CONFIGURATION_FORM.fields.CONSIGNEE_ID.visible && (
            <Col>
              <TextField
                name='configuration.consigneeId'
                label={
                  <Trans i18nKey='app.entity.form.configuration.consignee_id' />
                }
              />
            </Col>
          )}
        </Row>
        <Row>
          {FormPrivileges.CONFIGURATION_FORM.fields.DMS_REFERENCE.visible && (
            <Col>
              <TextField
                name='configuration.dmsRef'
                label={
                  <Trans i18nKey='app.entity.form.configuration.dms_ref_1' />
                }
              />
            </Col>
          )}
          {FormPrivileges.CONFIGURATION_FORM.fields.ELIGIBLE_TO_CONTAINER_ORDERS
            .visible && (
            <>
              <Col>
                <SwitchField
                  label={
                    <Trans i18nKey='app.entity.form.configuration.eligible_to_container_orders' />
                  }
                  name='configuration.eligibleToContainerOrders'
                  size='lg'
                  variant='SINGLE'
                  disabled={!isWriting}
                  direction='column'
                />
              </Col>
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ConfigurationForm;
